<template>
  <div class="container-fluid" >
      <!-- <router-view :key="reload"/> -->
      <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { onMounted, onUpdated, inject, ref, computed } from 'vue'
import { initStore } from '@/stores/store'

export default {
  setup () {

    initStore()

    const getMediaPreference = () => {
          const hasDarkPreference = window.matchMedia(
              "(prefers-color-scheme: dark)"
          ).matches

          if (hasDarkPreference) {
              return "dark-theme"
          } else {
              return "light-theme"
          }
      }


    onMounted(async() => {

        // console.log("Current API URL:", process.env.VUE_APP_API_BASE_URL)

        const currentTheme = localStorage.getItem('theme')
        if (currentTheme !== null && currentTheme !== undefined) {
            localStorage.setItem('theme', currentTheme)
        } else {
            const initTheme = getMediaPreference()
            localStorage.setItem('theme', initTheme)
        }

        const theme = localStorage.getItem('theme')
        if (theme) {
            document.documentElement.className = theme // default theme
        }

    
    })
    
    return { }

  }

}
</script>

<style>
</style>
